module.exports = __webpack_public_path__ + "static/media/refer-and-earn.723e03b5.svg";